import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { resources } from './resources';

export const DEFAULT_LANGUAGE = 'pt-BR';
export const SUPPORTED_LANGUAGES = ['pt-BR', 'en', 'es'];
export const LANGUAGE_STORAGE_KEY = 'sante.participant.language';

function readStoredLanguage() {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return SUPPORTED_LANGUAGES.includes(stored) ? stored : DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
}

function persistLanguage(language) {
  if (!SUPPORTED_LANGUAGES.includes(language)) return;
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // A interface continua funcionando com o idioma em memória.
  }
}

function syncDocumentLanguage(language) {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = language;
  document.documentElement.dir = 'ltr';
}

const initialLanguage = readStoredLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    compatibilityJSON: 'v3',
    returnEmptyString: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

syncDocumentLanguage(initialLanguage);
persistLanguage(initialLanguage);

i18n.on('languageChanged', (language) => {
  const resolved = SUPPORTED_LANGUAGES.includes(language) ? language : DEFAULT_LANGUAGE;
  persistLanguage(resolved);
  syncDocumentLanguage(resolved);
});

export function formatLocalizedDate(value, language = i18n.resolvedLanguage || DEFAULT_LANGUAGE) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(language).format(date);
}

export function getLocalizedRegionName(regionCode, language = i18n.resolvedLanguage || DEFAULT_LANGUAGE) {
  try {
    return new Intl.DisplayNames([language], { type: 'region' }).of(regionCode) || regionCode;
  } catch {
    return regionCode;
  }
}

export default i18n;
